import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation } from './navigation'
import { splitType } from './splitType'
import { initLenis, cancelRaf, lenis } from './lenis'
import { initAlpine } from './alpine'
import { initSwiper } from './swiper'
import { introBanner, inviewHeading, parallaxSections, parallaxFooter } from './animation'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {
  const nav = new Navigation()

  barba.init({
    debug: true,
    timeout: 10000,
    schema: {
      prefix: 'data-load'
    },
    transitions: [
      {
        sync: true,
        once() {},
        leave(data) {
          document.documentElement.dataset.reduceHeader = false
          document.documentElement.dataset.scrollDirection = 'backwards'
          return gsap.to(data.current.container, {
            duration: 1.35,
            yPercent: -25,
            opacity: 0.1,
            ease: 'expo.inOut'
          })
        },
        enter(data) {
          document.documentElement.dataset.reduceHeader = false
          document.documentElement.dataset.scrollDirection = 'backwards'
          return gsap.fromTo(
            data.next.container,
            {
              yPercent: 100
            },
            {
              duration: 1.35,
              yPercent: 0,
              ease: 'expo.inOut'
            }
          )
        },
        afterEnter(data) {},
        after(data) {}
      }
    ]
  })

  barba.hooks.once((data) => {
    initLenis()
    initAlpine()
    initSwiper()
    parallaxFooter()
    parallaxSections()
    splitType()
    nav.setActiveState()

    document.fonts.ready.then(() => {
      introBanner()
      inviewHeading()
    })
  })

  barba.hooks.leave((data) => {
    lenis.stop()
  })

  barba.hooks.enter((data) => {
    splitType()
    cancelRaf()
    lenis.destroy()
    nav.closeNavigation()
    nav.setActiveState()
    htmx.process(data.next.container)
  })

  barba.hooks.after((data) => {
    initLenis()
    initSwiper()
    introBanner()
    inviewHeading()
    parallaxFooter()
    parallaxSections()

    document.querySelectorAll('video[autoplay]').forEach((video) => video.play())
  })
}

export default initBarba
